/* eslint no-bitwise: ["error", { "allow": ["~"] }] */
import React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import MinigraphCard from "./minigraphCard";
import WordCloud from "./d3/WordCloud";
import AnalyticsLoading from "../analyticsLoading";
import AnalyticsError from "../analyticsError";
import _ from "underscore";

const MINIMUM_DATA_LENGTH = 10;

interface TopWordsCardProps {
  devMode: boolean;
  data: any[];
  fetchTopWordsData: any;
  requestStatus: string;
}

export default class TopWordsCard extends React.Component<
  TopWordsCardProps,
  any
> {
  wordCloudContainer: HTMLDivElement;
  svg: SVGSVGElement;

  componentDidUpdate(prevProps: TopWordsCardProps) {
    if (prevProps.data !== this.props.data) {
      if (this.props.requestStatus === "success" && this.props.data !== null) {
        const wordCloud = new WordCloud(
          this.wordCloudContainer,
          this.svg,
          this.props.data
        );
        wordCloud.createTopWordsChart();
      }
    }
  }

  componentDidMount() {
    if (_.isEmpty(this.props.data)) {
      this.props.fetchTopWordsData();
    }
    if (this.props.requestStatus === "success" && this.props.data !== null) {
      const wordCloud = new WordCloud(
        this.wordCloudContainer,
        this.svg,
        this.props.data
      );
      wordCloud.createTopWordsChart();
    }
  }

  render() {
    return (
      <MinigraphCard
        devMode={this.props.devMode}
        title={this.getTitle()}
        url={this.getUrl()}
        chartName="top_words"
      >
        <div
          className="word-cloud"
          ref={(node) => {
            this.wordCloudContainer = node;
          }}
        >
          <svg
            ref={(node) => {
              this.svg = node;
            }}
            style={this.getSvgStyles()}
          />
          {this.renderWarnings()}
        </div>
      </MinigraphCard>
    );
  }

  renderWarnings = () => {
    if (this.props.requestStatus === "error") {
      return (
        <AnalyticsError
          error={i18n.translate("analyticsv2.something_went_wrong")}
        />
      );
    }
    if (this.props.requestStatus === "loading") {
      return <AnalyticsLoading />;
    }
    if (this.notEnoughData()) {
      return (
        <AnalyticsError
          error={i18n.translate("analyticsv2.top_words_card.not_enough_data")}
        />
      );
    }

    return null;
  };

  getSvgStyles = () => {
    if (this.props.requestStatus === "loading" || this.notEnoughData()) {
      return { display: "none" };
    }

    return {};
  };

  getTitle = () => {
    return "Top Words";
  };

  getUrl = () => {
    return "/analytics/words";
  };

  notEnoughData = () => {
    return this.props.data.length < MINIMUM_DATA_LENGTH;
  };
}
